import { FC } from 'react';
import classNames from 'classnames';

import { Counter } from '@/components';
import { NOT_DEFINED } from '@/constants';

import {
  getDefaultProductInfoComponents,
  ProductActionFavorite,
  ProductBadgeContainer,
  ProductImage,
  ProductInfoCarousel,
  ProductLinkWrapper,
  ProductName,
  ProductPrice,
  ProductVariants,
} from '../Product.components';

import style from '../product.module.scss';
import styleVariation from './ProductCardTraditional.module.scss';

import { ProductVariationProps } from '../Product';
import { useProductContext } from '../context';

const ProductCardTraditional: FC<ProductVariationProps> = ({
  className,
  analyticsListName,
  isLargeCard,
}) => {
  const { product, isSpecial, variants, weightVariant, compoundList } =
    useProductContext();

  const availableInfo = getDefaultProductInfoComponents(product, compoundList);

  return (
    <ProductLinkWrapper
      analyticsListName={analyticsListName}
      className={classNames(style.product, styleVariation.product, className)}
      product={product}
    >
      <ProductImage
        className={styleVariation.product__image_container}
        product={product}
      />
      <div
        className={classNames(
          style.product__body,
          styleVariation.product__body,
        )}
      >
        <ProductBadgeContainer
          className={styleVariation.product_badge}
          key="badge-container"
          product={product}
          weightVariant={weightVariant}
        />
        <ProductInfoCarousel
          className={styleVariation.variation__info_carousel}
        >
          {availableInfo}
        </ProductInfoCarousel>
        <ProductName name={product?.name || NOT_DEFINED} />
        <div className={styleVariation.product__actions_footer}>
          <ProductPrice
            elementVariants={<ProductVariants />}
            isOverflow={variants?.length === 1}
            isSpecial={isSpecial}
            type="column-container"
            weightVariant={weightVariant}
          />
          <Counter
            actionTheme="primary"
            className={classNames(styleVariation.actions__counter, {
              [styleVariation.actions__counter_large_card]: isLargeCard,
            })}
            omitCheckAvilibility
            onCard
            product={product}
            selectedWeightVariant={weightVariant}
            showIcon
          />
        </div>
        <div className={styleVariation.actions__body}>
          <ProductActionFavorite
            className={styleVariation.favorite__button}
            product={product}
          />
        </div>
      </div>
    </ProductLinkWrapper>
  );
};

export { ProductCardTraditional };
